import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRemarks } from '../../actions/admin';
import { debounce } from '../../utils/common';
import { CLEAR_REMARKS_LIST_DROPDOWN_LIST_DATA } from '../../types/admin';
import { useFormContext } from 'react-hook-form';
import Select from '../../common/Form/Select';

const RenderRemarksInput = ({ name, label, onChange = () => { }, category, org_id, project_id, required = true, className = '', prefill = [], helpdesk_id }) => {
    const dispatch = useDispatch();
    const remarksListDropdown = useSelector((state) => state.admin.remarksListDropdown);
    const isRemarksLoading = useSelector((state) => state.loading.isRemarksLoading);
    const [inputValue, setInputValue] = useState('');
    const { setValue } = useFormContext();

    const getRemarksList = ({ limit = 100, page = 1, query = '', org_id, project_id, helpdesk_id }) => {
        let org_ids = org_id;
        if (helpdesk_id) org_ids = `${org_ids},${helpdesk_id}`
        dispatch(getRemarks({ limit, page, query, org_id: org_ids, category, project_id, dropdown: true }));
    };

    const debouncedRemarksSearchSearch = useCallback(debounce(getRemarksList), []);

    const remarksList = useMemo(() => {
        let l = [];
        if (remarksListDropdown?.[category]) {
            l = [...remarksListDropdown[category]];
        }
        return l;
    }, [remarksListDropdown, category]);

    useEffect(() => {
        getRemarksList({ limit: 100, page: 1, query: '', org_id, project_id, helpdesk_id });
    }, [org_id, project_id, helpdesk_id]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_REMARKS_LIST_DROPDOWN_LIST_DATA, payload: category });
        }
    }, [dispatch]);

    const handleInputChange = (inputText) => {
        setInputValue(inputText);
        if (inputText.length > 0) {
            debouncedRemarksSearchSearch({ query: inputText, org_id, helpdesk_id });
        }
    };

    const getOptions = () => {
        const options = [...remarksList];
        if (inputValue && !options.find(opt => opt.label.toLowerCase() === inputValue.toLowerCase())) {
            options.push({ value: `create_this_issue`, label: inputValue });
        }
        return options;
    };

    useEffect(() => {
        if (prefill.length > 0 && remarksList.length > 0) {
            const prefillValue = remarksList.find(option => prefill.includes(option.value));
            if (prefillValue) {
                setValue(name, prefillValue);
            }
        }
    }, [prefill, remarksList]);

    return <Select
        name={name}
        label={label}
        options={getOptions()}
        isLoading={isRemarksLoading}
        required={required}
        shouldUnregister
        isSearchable={true}
        isClearable={true}
        onChange={(event) => {
            const value = event?.value;
            onChange(value);
        }}
        onInputChange={handleInputChange}
        allowCreateWhileLoading={true}
        createOptionPosition="first"
        className={className}
        placeholder={(remarksList && remarksList.length > 0) ? 'Select' : 'Type Remarks and Enter...'}
    />
}

export default RenderRemarksInput;


